import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "./reduxToolkit/store";
import Routers from "./routers/RouterProvider";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <Provider store={store}>
      <RouterProvider router={Routers} />
      <ToastContainer />
    </Provider>
  );
};

export default App;
